import { render, staticRenderFns } from "./mediaDetails.vue?vue&type=template&id=6295bc56&scoped=true"
import script from "./mediaDetails.vue?vue&type=script&lang=js"
export * from "./mediaDetails.vue?vue&type=script&lang=js"
import style0 from "./mediaDetails.vue?vue&type=style&index=0&id=6295bc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6295bc56",
  null
  
)

export default component.exports